export const dateTimeFormat = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
}

export default {
  'common.logout': 'Logout',
  'common.organisation': 'Organisation | Organisations',
  'common.offer': 'Project | Projects',
}
